'use client';

import classNames from 'classnames';
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
  AccordionItemState
} from 'react-accessible-accordion';

import { IBlockFaq } from 'app/interfaces/blocks';
import { defaultProcessText } from 'app/utility/textProcessing';
import { IconArrow } from 'app/components/sprites';

import styles from '@/app/assets/styles/RichText.module.scss';

export default function BlockFaq({ block }: { block: IBlockFaq }) {
  const validItems =
    block?.data?.items?.filter(
      item => item?.question?.trim() && item?.answer?.trim()
    ) || [];

  if (!validItems.length) return null;

  const { title } = block.data;

  return (
    <section className="grid gap-8 xl:grid-cols-2 xl:gap-4">
      <div className="flex flex-col gap-6 xl:col-start-2 md:px-10">
        {!!title && <h2 className="text-p1 text-brown">{title}</h2>}

        <Accordion
          allowZeroExpanded
          allowMultipleExpanded
          className="border-t border-brown-20"
        >
          {validItems.map((item, index) => (
            <AccordionItem
              key={index}
              uuid={index}
              className="border-b border-brown-20"
            >
              <AccordionItemHeading>
                <AccordionItemButton className="group flex items-start justify-between gap-4 w-full py-5 text-left cursor-pointer">
                  <span
                    className="text-p2 md:text-lg font-book text-brown transition-colors duration-300 with-hover:group-hover:text-brown-darker"
                    dangerouslySetInnerHTML={{
                      __html: defaultProcessText(item.question)
                    }}
                  ></span>
                  <AccordionItemState>
                    {({ expanded }) => (
                      <IconArrow
                        className={classNames(
                          'shrink-0 w-2 h-3.5 mt-1 fill-none stroke-brown transition-transform duration-300',
                          expanded ? '-rotate-90' : 'rotate-90'
                        )}
                      />
                    )}
                  </AccordionItemState>
                </AccordionItemButton>
              </AccordionItemHeading>
              <AccordionItemPanel className="pb-6 -mt-1">
                <div
                  className={classNames(styles.content)}
                  dangerouslySetInnerHTML={{
                    __html: defaultProcessText(item.answer)
                  }}
                ></div>
              </AccordionItemPanel>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
